export const PatientSurgeryNotPresentAssessmentCard = () => {
  return (
    <div className="card border shadow">
      <div className="card-body">
        <p className="mb-0">El paciente no se presentó a la valoración.</p>
      </div>
    </div>
  );
};
